import { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';

import { AssetMediaKind } from '../config/types';

export const getAssetMediaKind = (
  asset: Asset | undefined,
): AssetMediaKind | null => {
  if (asset?.Kind.case !== 'Study') {
    return null;
  }

  const contentCase = asset.Kind.value.Content.case;

  if (contentCase === 'DentalPhoto') {
    return 'photo';
  }

  if (contentCase === 'DentalVideo') {
    return 'video';
  }

  return null;
};
